import roundToNearestMinutes from 'date-fns/roundToNearestMinutes';

const HALF_HOUR_IN_MILLISECONDS = 30 * 60 * 1000;
const ONE_HOUR_IN_MILLISECONDS = HALF_HOUR_IN_MILLISECONDS * 2;
const FOUR_HOURS_IN_MILLISECONDS = 4 * ONE_HOUR_IN_MILLISECONDS;
const today = new Date().getTime();

const roundTimeToNearestFifteenMinutes = (date) =>
    roundToNearestMinutes(date, {
        nearestTo: 15,
    });

export const fourHoursFromNowStart = roundTimeToNearestFifteenMinutes(
    new Date(today + FOUR_HOURS_IN_MILLISECONDS),
).toISOString();
export const fourHoursFromNowEndShortSession = roundTimeToNearestFifteenMinutes(
    new Date(today + FOUR_HOURS_IN_MILLISECONDS + HALF_HOUR_IN_MILLISECONDS),
).toISOString();
export const fourHoursFromNowEnd = roundTimeToNearestFifteenMinutes(
    new Date(today + FOUR_HOURS_IN_MILLISECONDS + ONE_HOUR_IN_MILLISECONDS),
).toISOString();
export const fourHoursAgoStart = roundTimeToNearestFifteenMinutes(
    new Date(today - FOUR_HOURS_IN_MILLISECONDS),
).toISOString();
export const fourHoursAgoEnd = roundTimeToNearestFifteenMinutes(
    new Date(today - FOUR_HOURS_IN_MILLISECONDS + ONE_HOUR_IN_MILLISECONDS),
).toISOString();

export const PLACEHOLDER_ACTIVE_SESSION = {
    name: 'Current Session',
    description:
        'This is where the description for the current session will appear. Visit any session in the Session Manager to edit its description, speakers, date, virtual content, or tags.',
    speakers: [
        {
            id: '1',
            firstName: 'Speaker',
            lastName: 'Name',
            jobTitle: 'Speaker Title',
            company: 'Speaker Company',
            avatarUrl: '',
            bio: 'This is a placeholder speaker bio.',
        },
    ],
};

export const mockSession = {
    id: 2,
    start: fourHoursFromNowStart,
    end: fourHoursFromNowEndShortSession,
    tags: ['Example Tag 1', 'Example Tag 2'],
    speakers: [
        {
            id: '1',
            firstName: 'Speaker',
            lastName: 'Name',
            jobTitle: 'Speaker Title',
            company: 'Speaker Company',
            avatarUrl: 'https://d24wuq6o951i2g.cloudfront.net/images/avatar.png',
            bio: 'This is a placeholder speaker bio.',
        },
    ],
    name: 'Current Session',
    description:
        'This is where the description for the current session will appear. Visit any session in the Session Manager to edit its description, speakers, date, virtual content, or tags.',
};

export const mockUpcomingSessions = [
    {
        id: 2,
        start: fourHoursFromNowStart,
        end: fourHoursFromNowEndShortSession,
        tags: ['Example Tag 1', 'Example Tag 2'],
        speakers: [
            {
                id: '1',
                firstName: 'Speaker',
                lastName: 'Name',
                jobTitle: 'Speaker Title',
                company: 'Speaker Company',
                avatarUrl: 'https://d24wuq6o951i2g.cloudfront.net/images/avatar.png',
                bio: 'This is a placeholder speaker bio.',
            },
            {
                id: '2',
                firstName: 'Speaker',
                lastName: 'Name',
                jobTitle: 'Speaker Title',
                company: 'Speaker Company',
                avatarUrl: 'https://d24wuq6o951i2g.cloudfront.net/images/avatar.png',
                bio: 'This is a placeholder speaker bio.',
            },
        ],
        name: 'Example Upcoming Session 1',
        description:
            'This is where the description for the current session will appear. Visit any session in the Session Manager to edit its description, speakers, date, virtual content, or tags.',
        types: ['virtual'],
        virtualVenue: {
            embeds: [
                {
                    type: 'zoom',
                    options: {
                        zoom: {
                            embedMessage: 'When prompted, sign in to Zoom to enter the virtual room',
                        },
                    },
                },
            ],
        },
    },
    {
        id: 3,
        start: fourHoursFromNowStart,
        end: fourHoursFromNowEnd,
        tags: [],
        speakers: [
            {
                id: '1',
                firstName: 'Speaker',
                lastName: 'Name',
                jobTitle: 'Speaker Title',
                company: 'Speaker Company',
                avatarUrl: 'https://d24wuq6o951i2g.cloudfront.net/images/avatar.png',
                bio: 'This is a placeholder speaker bio.',
            },
        ],
        name: 'Example Upcoming Session 2',
        description:
            'This is where the description for the current session will appear. Visit any session in the Session Manager to edit its description, speakers, date, virtual content, or tags.',
        types: ['virtual'],
        virtualVenue: {
            embeds: [
                {
                    type: 'vimeo',
                    options: {
                        zoom: {
                            embedMessage: 'When prompted, sign in to Zoom to enter the virtual room',
                            meetingId: '',
                        },
                        vimeo: {
                            videoId: '76979871',
                        },
                        custom: {
                            embedCode: '',
                        },
                    },
                },
            ],
        },
    },
    {
        id: 4,
        start: fourHoursFromNowStart,
        end: fourHoursFromNowEnd,
        tags: [],
        speakers: [],
        name: 'Example Upcoming Session 3',
        description:
            'This is where the description for the current session will appear. Visit any session in the Session Manager to edit its description, speakers, date, virtual content, or tags.',
        types: ['virtual'],
    },
];

export const mockPastSessions = [
    {
        id: 0,
        start: fourHoursAgoStart,
        end: fourHoursAgoEnd,
        tags: ['Example Tag 1'],
        speakers: [
            {
                id: '1',
                firstName: 'Speaker',
                lastName: 'Name',
                jobTitle: 'Speaker Title',
                company: 'Speaker Company',
                avatarUrl: 'https://d24wuq6o951i2g.cloudfront.net/images/avatar.png',
                bio: 'This is a placeholder speaker bio.',
            },
        ],
        name: 'Example Past Session 1',
        description:
            'This is where the description for the current session will appear. Visit any session in the Session Manager to edit its description, speakers, date, virtual content, or tags.',
        types: ['virtual'],
        virtualVenue: {
            embeds: [
                {
                    type: 'zoom',
                    options: {
                        zoom: {
                            embedMessage: 'When prompted, sign in to Zoom to enter the virtual room',
                        },
                    },
                    onDemandRecording: true,
                },
            ],
        },
    },
    {
        id: 1,
        start: fourHoursAgoStart,
        end: fourHoursAgoEnd,
        tags: [],
        speakers: [],
        name: 'Example Past Session Without On Demand',
        description:
            "This is how sessions that don't have the On Demand feature enabled will appear. Note how the button is shown disabled in this case.",
        types: ['virtual'],
        virtualVenue: {
            embeds: [
                {
                    type: 'custom',
                    options: {},
                    onDemandRecording: false,
                },
            ],
        },
    },
];

export const mockSessions = [
    {
        id: 1,
        tags: ['Example Tag 1', 'Example Tag 2', 'Example Tag 3', 'Example Tag 4'],
        speakers: [
            {
                id: 1,
                firstName: 'Speaker',
                lastName: 'Name',
                jobTitle: 'Speaker Title',
                company: 'Speaker Company',
            },
            {
                id: 2,
                firstName: 'Speaker',
                lastName: 'Name',
                jobTitle: 'Speaker Title',
                company: 'Speaker Company',
            },
        ],
        name: 'Session example',
        description:
            'This is where the description for the current session will appear. Visit any session in the Session Manager to edit the content. ',
        registration_required: false,
        status: 'open',
        waitlist: false,
        start: fourHoursFromNowStart,
        end: fourHoursFromNowEnd,
    },
    {
        id: 2,
        start: fourHoursFromNowStart,
        registration_required: true,
        end: fourHoursFromNowEndShortSession,
        tags: ['Example Tag 1', 'Example Tag 2'],
        speakers: [
            {
                id: '1',
                firstName: 'Speaker',
                lastName: 'Name',
                jobTitle: 'Speaker Title',
                company: 'Speaker Company',
                avatarUrl: 'https://d24wuq6o951i2g.cloudfront.net/images/avatar.png',
                bio: 'This is a placeholder speaker bio.',
            },
        ],
        name: 'Session example 2',
        description:
            'This is where the description for the current session will appear. Visit any session in the Session Manager to edit its description, speakers, date, virtual content, or tags.',
    },
];

const mockWaitlistSession = {
    id: 3,
    tags: ['Example Tag 1', 'Example Tag 2'],
    speakers: [
        {
            id: 1,
            firstName: 'Speaker',
            lastName: 'Name',
            jobTitle: 'Speaker Title',
            company: 'Speaker Company',
        },
    ],
    name: 'session example 3',
    description:
        'This is where the description for the current session will appear. Visit any session in the Session Manager to edit the content.',
    registration_required: true,
    attendee_count: 0,
    capacity: 0,
    status: 'open',
    waitlist: true,
    start: fourHoursFromNowStart,
    end: fourHoursFromNowEnd,
};

export const mockSessionRegistration = {
    sessionsRegistered: mockSessions,
    sessionsWaitlisted: [mockWaitlistSession],
    sessionsSkipped: [],
};
